export default "__VITE_ASSET__CGWuq8lm__"